import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    flexWrap: 'wrap',
    // justifyContent: 'space-between',
    gridTemplateColumns: '1fr 2fr',
    alignItems: 'center',
    columnGap: 25,
    marginBottom: 20,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 0,
      gridTemplateColumns: '1fr',
      rowGap: 10,
      columnGap: 0
    }
  },
  filters: {
    display: 'grid',
    gridTemplateColumns: '1fr 0.98fr 0.98fr',
    alignItems: 'center',
    columnGap: 25,
    marginTop: 20,
    marginBottom: 20,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 0,
      gridTemplateColumns: '1fr',
      rowGap: 10,
      columnGap: 0
    }
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12
  },
  backitemContainer: {
    marginTop: -22,
    marginLeft: -96,
    marginRight: -96,
    marginBottom: 56,
    [theme.breakpoints.down('sm')]: {
      marginLeft: -17,
      marginRight: -15
    }
  },
  roleSelectorContainer: {
    width: '25%',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: 12
    }
  },
  searchInput: {
    marginBottom: 12
  },
  clearIconButton: {
    position: 'absolute',
    top: '5%',
    right: 32,
    cursor: 'pointer'
  },
  clearIcon: {
    fontSize: 16
  },
  entitySelectorContainer: {
    width: '46%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: 12
    }
  },
  resourceTypeSelectorContainer: {
    width: '25%',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  }
}))

export default useStyles
